(() => {
  const selector = 'a[href]';
  const excluded = 'script, style, textarea, template, svg, .ibead-link-arrow';

  function separateArrows(link) {
    if (!link.textContent.includes('→')) return;
    const walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        return node.data.includes('→') && !node.parentElement.closest(excluded)
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      }
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (const node of nodes) {
      const fragment = document.createDocumentFragment();
      let offset = 0;
      for (const match of node.data.matchAll(/[ \u00a0]*→/g)) {
        fragment.append(document.createTextNode(node.data.slice(offset, match.index)));
        const arrow = document.createElement('span');
        arrow.className = 'ibead-link-arrow';
        const glyph = document.createElement('span');
        glyph.textContent = match[0];
        arrow.append(glyph);
        fragment.append(arrow);
        offset = match.index + match[0].length;
      }
      fragment.append(document.createTextNode(node.data.slice(offset)));
      node.replaceWith(fragment);
    }
  }

  function collectLinks(node, links) {
    const element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
    if (!element || element.closest(excluded)) return;
    const parentLink = element.closest(selector);
    if (parentLink) links.add(parentLink);
    if (node.nodeType === Node.ELEMENT_NODE) {
      node.querySelectorAll(selector).forEach(link => links.add(link));
    }
  }

  function initialize() {
    document.querySelectorAll(selector).forEach(separateArrows);
    new MutationObserver(records => {
      const links = new Set();
      for (const record of records) {
        if (record.type === 'characterData') collectLinks(record.target, links);
        else record.addedNodes.forEach(node => collectLinks(node, links));
      }
      links.forEach(separateArrows);
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
